import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-grid-system";
import PageLayout from "../layouts/MainLayout";

const ErrorPage = () => {
  return (
    <PageLayout pageHeader="Page Not Found">
      <Container>
        <Row>
          <Col md={12}>
            <p>The page you requested could not be found. The builder may not exist, or the link may be incorrect.</p>
            <Link to="/">Return to Search</Link>
          </Col>
        </Row>
      </Container>
    </PageLayout>
  );
};
export default ErrorPage;
